import z from "zod";

export const getVehicleIntegrationParamSchema = z.object({
	integrationId: z.uuid(),
});

export type getVehicleIntegrationParamSchema = z.infer<typeof getVehicleIntegrationParamSchema>;
